import { Flex } from "rebass";
import StyledTag from "../../../../Components/Common/StyledTag";

const SadnessCause = ({ causes }) => (
  <Flex
    justifyContent="center"
    alignItems="center"
  >
    <Flex width="fit-content">
      <StyledTag
        bgColor={causes?.length > 0 ? "#E2F6FE" : "#E8E8E8"}
        highlighted={true}
        textColor="#153962"
        title={causes?.length > 0 ? causes.join(", ") : "ไม่พบข้อมูล"}
      />
    </Flex>
  </Flex>
);

export default SadnessCause;
